<div class="validation-field-option">
  @if (fieldOptions) {
    <div class="select-search-field">
      <select-filter
        (constant_changed)="setSelectedField($event);"
        [modelValue]="value"
        [options]="fieldOptions"
        [class]="'select-filter-inline'">
      </select-filter>
    </div>
  }
</div>
